import { Row, Col } from "react-bootstrap";
import "../style/LucrareItem.css";
import { useNavigate } from "react-router-dom";

const DomeniuFolderItem = ({
  folderName,
  locationType,
  setFolderToDelete,
}) => {
  const navigate = useNavigate();

  return (
    <Row className={"mb-1"}>
      <Row className="row_folder">
        <Col
          onClick={() => {
            navigate("/documenteDomeniuViewer", {
              state: { locationType, folderName },
            });
          }}
          className="lucrare_folder_data"
          style={{ background: "#87cefa" }}
          onContextMenu={(e) => {
            e.preventDefault();
            setFolderToDelete(folderName);
          }}
        >
          {folderName || ""}
        </Col>
      </Row>
    </Row>
  );
};
export default DomeniuFolderItem;
